// extracted by mini-css-extract-plugin
module.exports = {"container":"GZx8nA1-TC4YvaEVplsgbQ==","dimLayer":"XeC-sE54iJ9JZRB6M3FCMg=="};